import React from "react";
import "../../styles/admin/AdminHeader.css";

export default function AdminHeader({ title }) {
    return (
        <div className="admin-header">
            <h1 className="admin-page-title">{title}</h1>
        </div>
    );
}
